import { FormControl, FormLabel } from '@mui/material';
import { ReactNode } from 'react';

interface InlineFormControlProps {
	label: string;
	width: number;
	invert?: boolean;
	children: ReactNode;
}

export const InlineFormControl = ({ label, width, invert = false, children }: InlineFormControlProps) => (
	<FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
		{!invert && <FormLabel sx={{ width }}>{label}</FormLabel>}
		{children}
		{invert && <FormLabel sx={{ width }}>{label}</FormLabel>}
	</FormControl>
);
